import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';

import { EnvironmentCreate } from '../../interfaces';
import { FsDialogModule } from '@firestitch/dialog';
import { LogoComponent } from '../../../../../../libs/logo/components/logo/logo.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardContent } from '@angular/material/card';

import { WorkspaceComponent } from '../workspace/workspace.component';
import { InviteComponent } from '../invite/invite.component';
import { ProgressComponent } from '../progress/progress.component';


@Component({
    templateUrl: './create.component.html',
    styleUrls: ['./create.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    FsDialogModule,
    LogoComponent,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatCard,
    MatCardContent,
    WorkspaceComponent,
    InviteComponent,
    ProgressComponent
],
})
export class CreateComponent implements OnInit {
  private _data = inject(MAT_DIALOG_DATA);
  private _dialogRef = inject<MatDialogRef<CreateComponent>>(MatDialogRef);


  public environmentCreate: EnvironmentCreate = { members: [] };
  public step = 0;

  public ngOnInit(): void {
    this._dialogRef
      .addPanelClass('full-width-dialog')
      .addPanelClass('environment-create');
  }

  public stepNext(): void {
    this.step ++;
  }

  public close(): void {
    this._dialogRef.close();
  }

}
